
















































































































import {Component, Vue, Prop} from 'vue-property-decorator'
import Overlay from '@/components/common/Overlay.vue'
import {Getter, Mutation, Action} from 'vuex-class'
import {InventoryItem as InventoryItemInterface, ItemType, Room} from '@/store/types'
import InventoryItem from '@/components/inventory/InventoryItem.vue'
import ToggleButton from 'vue-js-toggle-button/src/Button.vue'
import LeadRoomInventoryModel from '@/classes/LeadRoomInventoryModel'
import Errors from '@/classes/Errors'
import LengthFormatter from '@/classes/LengthFormatter'
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'

@Component({
  components: {
    Overlay,
    InventoryItem,
    ToggleButton,
    AppHeader,
    AppFooter,
  },
})
export default class InventoryNewItemOverlay extends Vue {
  @Getter('activeItemTypeQuantity') public activeItemTypeQuantity!: number
  @Getter('activeItemType') public activeItemType!: ItemType
  @Getter('activeRoom') public activeRoom!: Room
  @Getter('itemTypes') public itemTypes!: ItemType[]
  @Mutation('setInventoryItemListOverlay') public setInventoryItemListOverlay!: any
  @Mutation('setInventoryNewItemOverlay') public setInventoryNewItemOverlay!: any
  @Mutation('resetActiveItemType') public resetActiveItemType!: any
  @Mutation('setAddedItem') public setAddedItem!: any
  @Mutation('setActiveItemTypeQuantity') public setActiveItemTypeQuantity!: any
  @Action('addRoomItem') public addRoomItem!: any
  @Action('addCustomRoomItem') public addCustomRoomItem!: any
  @Action('openInventoryAddedItem') public openInventoryAddedItem!: any
  @Action('focusSearch') public focusSearch!: any

  public LengthFormatter = LengthFormatter
  public LeadRoomInventoryModel: any = LeadRoomInventoryModel
  public errors = new Errors()
  public packing: number = LeadRoomInventoryModel.PACKED_BY.MOVERS
  public crate: boolean = false
  public width: any = null
  public height: any = null
  public depth: any = null
  public name: string = ''
  public volume: number = 0
  public measureUnit: string = LengthFormatter.UNIT.INCH
  public isCustomQuantity: boolean = false

  public get quantity() {
    return this.activeItemTypeQuantity
  }
  public set quantity(q) {
      this.setActiveItemTypeQuantity(q)
  }
  public get calculatedVolume() {
    if (this.customDimensions) {
      let vol = Math.round(this.width * this.height * this.depth)
      if (this.measureUnit === LengthFormatter.UNIT.INCH) {
        vol = Math.round(LengthFormatter.inchToFoot(this.width) *
          LengthFormatter.inchToFoot(this.height) * LengthFormatter.inchToFoot(this.depth))
      }
      return vol > 0 ? vol : 1
    }
    if (this.volume) {
      return this.volume
    }
    return this.activeItemType.volume
  }

  public get isCustom() {
    return this.activeItemType.custom !== undefined && this.activeItemType.custom
  }

  public get customDimensions() {
    return (this.crate || this.isCustom || !(this.width === null || this.width === '') ||
      !(this.height === null || this.height === '') ||
      !(this.depth === null || this.depth === ''))
  }

  public get dimensionsValid() {
    return this.width * 1 && this.height * 1 && this.depth * 1
  }

  public closeCustomQuantity() {
    this.isCustomQuantity = false
  }

  public clearCustomDimensions() {
    this.width = ''
    this.height = ''
    this.depth = ''
  }

  public resetCustomDimensions() {
    if (this.dimensionsValid && !this.isCustom) {
      this.clearCustomDimensions()
    }
  }

  public dimensionInput() {
    if (this.dimensionsValid) {
      this.volume = this.calculatedVolume
    }
    this.clearErrors()
  }

  public clearErrors() {
    this.errors.clear()
  }

  public switchPacking(packing: number) {
    this.packing = packing
  }

  public switchMeasureUnit(unit: string) {
    if (this.measureUnit === unit) {
      return
    }
    this.measureUnit = unit
    if (this.measureUnit === LengthFormatter.UNIT.INCH) {
      this.width = LengthFormatter.footToInch(this.width)
      this.height = LengthFormatter.footToInch(this.height)
      this.depth = LengthFormatter.footToInch(this.depth)
    }
    if (this.measureUnit === LengthFormatter.UNIT.FOOT) {
      this.width = LengthFormatter.inchToFoot(this.width)
      this.height = LengthFormatter.inchToFoot(this.height)
      this.depth = LengthFormatter.inchToFoot(this.depth)
    }
  }

  public increaseQuantity() {
    this.quantity++
  }
  public decreaseQuantity() {
    if (this.quantity > 1) {
      this.quantity--
    }
  }

  public addItem() {
    if (this.customDimensions && !this.dimensionsValid) {
      let errors = {}
      if (!(this.width * 1)) {
        errors = Object.assign(errors, {width: ['width is required']})
      }
      if (!(this.height * 1)) {
        errors = Object.assign(errors, {height: ['height is required']})
      }
      if (!(this.depth * 1)) {
        errors = Object.assign(errors, {depth: ['depth is required']})
      }
      this.errors.record(errors)
      return
    }
    const data: any = {
      inventory_id: this.activeItemType ? this.activeItemType.id : '',
      lead_room_id: this.activeRoom.id,
      quantity: this.quantity,
      packed_by: this.packing,
      to_be_crated: this.crate,
      volume: this.calculatedVolume,
    }

    if (this.customDimensions && this.dimensionsValid) {
      let dimensions
      if (this.measureUnit === LengthFormatter.UNIT.FOOT) {
        dimensions = {
          width: LengthFormatter.footToInch(this.width),
          height: LengthFormatter.footToInch(this.height),
          depth: LengthFormatter.footToInch(this.depth),
        }
      } else {
        dimensions = {
          width: this.width,
          height: this.height,
          depth: this.depth,
        }
      }
      Object.assign(data, dimensions)
    }

    if (this.isCustom) {
      Object.assign(data, {name: this.name})
      this.addCustomRoomItem(data).then((response: InventoryItemInterface) => {
        this.setActiveItemTypeQuantity(1)
        this.resetActiveItemType()
        this.setInventoryNewItemOverlay(false)
      })
    } else {
      this.addRoomItem(data).then((response: InventoryItemInterface) => {
        this.setActiveItemTypeQuantity(1)
        this.resetActiveItemType()
        this.setInventoryNewItemOverlay(false)
      })
    }
    this.openInventoryAddedItem()
    this.setAddedItem(this.activeItemType)
  }
  public back() {
    this.setActiveItemTypeQuantity(1)
    this.resetActiveItemType()
    this.setInventoryNewItemOverlay(false)
  }
  public mounted() {
    this.volume = this.activeItemType.volume
    if (this.isCustom) {
      this.name = this.activeItemType.name
    }
    if (this.activeItemType.packed_by) {
      this.packing = this.activeItemType.packed_by
    }
  }
}
